import * as tslib_1 from "tslib";
import { OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { chunk, find, orderBy, sumBy } from 'lodash';
import { sentry } from 'sentry';
import { GroupService } from '../../../services/groups-api.service';
var TabSegmentsComponent = /** @class */ (function () {
    function TabSegmentsComponent(groupService) {
        this.groupService = groupService;
        this.isLoading = true;
        this.segments = [];
        this.isAllSelected = false;
        this.isSaving = [];
        this.linkedSegmentsCount = 0;
    }
    TabSegmentsComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.searchSegments()];
                    case 1:
                        _a.segments = _b.sent();
                        this.isAllSelected = this.checkIfIsAllSelected();
                        this.linkedSegmentsCount = this.countLinkedSegments();
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    TabSegmentsComponent.prototype.countLinkedSegments = function () {
        var _this = this;
        return sumBy(this.segments, function (segment) {
            return segment.groupsConnection.items.some(function (group) { return group.id === _this.group.id; }) ? 1 : 0;
        });
    };
    TabSegmentsComponent.prototype.ngOnChanges = function (changes) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!changes.group) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.searchSegments()];
                    case 1:
                        _a.segments = _b.sent();
                        this.isAllSelected = this.checkIfIsAllSelected();
                        this.linkedSegmentsCount = this.countLinkedSegments();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    TabSegmentsComponent.prototype.searchSegments = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var segments, totalCount, totalSegmentsFetched, offset, limit, page, _a, _b, segment;
            var e_1, _c;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!this.group.id) {
                            return [2 /*return*/, null];
                        }
                        segments = [];
                        totalCount = null;
                        totalSegmentsFetched = 0;
                        offset = 0;
                        limit = 100;
                        _d.label = 1;
                    case 1: return [4 /*yield*/, this.groupService.listSegments({
                            groupId: this.group.id,
                            limit: limit,
                            offset: offset,
                        })];
                    case 2:
                        page = _d.sent();
                        try {
                            for (_a = (e_1 = void 0, tslib_1.__values(page.items)), _b = _a.next(); !_b.done; _b = _a.next()) {
                                segment = _b.value;
                                if (segment.archived && segment.groupsConnection.items.length === 0) {
                                    continue;
                                }
                                segments.push(segment);
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        totalSegmentsFetched += segments.length;
                        totalCount = page.totalCount;
                        offset += limit;
                        _d.label = 3;
                    case 3:
                        if (totalCount > totalSegmentsFetched) return [3 /*break*/, 1];
                        _d.label = 4;
                    case 4: return [2 /*return*/, orderBy(segments, ['archived', 'name'])];
                }
            });
        });
    };
    TabSegmentsComponent.prototype.toggleAll = function (checked) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var segmentsToChange;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        segmentsToChange = this.segments.filter(function (segment) {
                            return checked !== !!segment.groupsConnection.items.length;
                        });
                        return [4 /*yield*/, this.toggleSegmentLinkedToGroup(checked, segmentsToChange)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TabSegmentsComponent.prototype.toggleSegmentLinkedToGroup = function (checked, segments) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var groupId, allChangedSegments, _a, _b, segmentIds, promise, e_2_1, segments_1, segments_1_1, segment, changedSegment, currentSegment;
            var e_2, _c, e_3, _d;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        this.isSaving.push(true);
                        segments.forEach(function (segment) { return segment['isSaving'] = true; });
                        groupId = this.group.id;
                        allChangedSegments = [];
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 6, 7, 8]);
                        _a = tslib_1.__values(chunk(segments.map(function (segment) { return segment.id; }), 100)), _b = _a.next();
                        _e.label = 2;
                    case 2:
                        if (!!_b.done) return [3 /*break*/, 5];
                        segmentIds = _b.value;
                        promise = checked
                            ? this.groupService.addSegmentToGroup({ groupId: groupId, segmentIds: segmentIds })
                            : this.groupService.removeSegmentFromGroup({ groupId: groupId, segmentIds: segmentIds });
                        return [4 /*yield*/, promise
                                .then(function (changedSegments) { return allChangedSegments.push.apply(allChangedSegments, tslib_1.__spread(changedSegments)); })
                                .catch(function (err) { sentry.captureException(err); })];
                    case 3:
                        _e.sent();
                        _e.label = 4;
                    case 4:
                        _b = _a.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_2_1 = _e.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7 /*endfinally*/];
                    case 8:
                        try {
                            for (segments_1 = tslib_1.__values(segments), segments_1_1 = segments_1.next(); !segments_1_1.done; segments_1_1 = segments_1.next()) {
                                segment = segments_1_1.value;
                                changedSegment = find(allChangedSegments, {
                                    id: segment.id
                                });
                                if (!changedSegment) {
                                    continue;
                                }
                                currentSegment = find(this.segments, {
                                    id: segment.id
                                });
                                currentSegment.groupsConnection.items = changedSegment.groupsConnection.items;
                            }
                        }
                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                        finally {
                            try {
                                if (segments_1_1 && !segments_1_1.done && (_d = segments_1.return)) _d.call(segments_1);
                            }
                            finally { if (e_3) throw e_3.error; }
                        }
                        this.isAllSelected = this.checkIfIsAllSelected();
                        this.linkedSegmentsCount = this.countLinkedSegments();
                        segments.forEach(function (segment) { return segment['isSaving'] = false; });
                        this.isSaving.pop();
                        return [2 /*return*/];
                }
            });
        });
    };
    TabSegmentsComponent.prototype.checkIfIsAllSelected = function () {
        return this.segments.length && this.segments.every(function (segment) { return segment.groupsConnection.items.length; });
    };
    return TabSegmentsComponent;
}());
export { TabSegmentsComponent };
